import { Link } from '@tanstack/react-router'
import { ChevronRightIcon } from 'lucide-react'

import { cn, formatNumber } from '@/utils'
import type { BreakdownRow } from '../toBreakdownRows'

const ROW_CLASS =
  'flex items-center justify-between gap-4 px-6 py-3 text-sm border-t'

const LINK_CLASS =
  'hover:bg-muted/50 cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset'

const rowContent = (row: BreakdownRow) => (
  <>
    <span
      className={cn('truncate', row.href === null && 'text-muted-foreground')}
      title={row.label}
    >
      {row.label}
    </span>
    <span className="flex shrink-0 items-center gap-2 tabular-nums">
      <span className="font-medium">{formatNumber(row.credits)}</span>
      <ChevronRightIcon
        className={cn(
          'text-muted-foreground size-4',
          row.href === null && 'invisible',
        )}
      />
    </span>
  </>
)

export const BreakdownListRow = ({ row }: { row: BreakdownRow }) => {
  if (row.href === null) return <li className={ROW_CLASS}>{rowContent(row)}</li>

  return (
    <li>
      <Link
        to={row.href}
        preload="intent"
        className={cn(ROW_CLASS, LINK_CLASS)}
      >
        {rowContent(row)}
      </Link>
    </li>
  )
}
